import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.iterator";
import stickybits from "stickybits";
//@ts-ignore
import { create } from "@wkWebSrc/js/components/pagination";
//@ts-ignore
import { EMAIL_REGEX, PHONE_REGEX, DATE_REGEX, EXCLUDED_REGEX } from "@utils/RegexUtils";
//@ts-ignore
import { shallowCopyObjectTo } from "@utils/ObjectUtils";
export var page = [];
export var LISTING_MODE;
(function (LISTING_MODE) {
  LISTING_MODE["MAP"] = "Mappa";
  LISTING_MODE["LIST"] = "Lista";
})(LISTING_MODE || (LISTING_MODE = {}));
var ListingInit = {
  click: true
};
export function init(opts) {
  shallowCopyObjectTo(opts, ListingInit);
  var insertionsListEl = document.querySelectorAll(".insertion");
  var _loop = function _loop() {
    var {
      url,
      id,
      agencyId
    } = insertion.dataset;
    page.push({
      id: parseInt(id || "".concat(-1)),
      agencyId: parseInt(agencyId || "".concat(-1)),
      url
    });
    var descriptionEl = insertion.querySelector(".description");
    var text = descriptionEl === null || descriptionEl === void 0 ? void 0 : descriptionEl.innerHTML.trim();
    if (!text || !descriptionEl) return 1; // continue
    text = text === null || text === void 0 ? void 0 : text.replace(EMAIL_REGEX, "***");
    text = text === null || text === void 0 ? void 0 : text.replace(PHONE_REGEX, (match, p1, p2, p3, offset) => {
      if (p1) return match;
      if (match.match(DATE_REGEX)) return match;
      var start = Math.max(0, offset - 6);
      var tmp = text === null || text === void 0 ? void 0 : text.substring(start, offset).toLowerCase();
      return EXCLUDED_REGEX.some(s => (tmp || "").indexOf(s.toLowerCase()) > -1) ? match : "***";
    });
    descriptionEl.innerHTML = text;
  };
  for (var insertion of insertionsListEl) {
    if (_loop()) continue;
  }
  stickybits("#listing-header", {
    useStickyClasses: true
  });
  if (!window["_count"] || !window["_currentPage"] || !window["_pageSize"]) return;
  var match = window.location.href.match(/(^[^#]*)/);
  var backURL = match ? match[0] : "";
  create(window["_count"], window["_pageSize"], window["_currentPage"], page, window["_serializedSearchBean"], backURL);
}